// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6884bdb2","453":"8405f1d2","455":"d751130e"}[chunkId] + ".chunk.js";
};